class CalculatorChoicesPresentation extends HTMLElement {
  constructor() {
    super();

    this.storedSelections = [];
    this.choicesPresentationContent = this.querySelector('[data-choices-presentation-content]');
    this.choicesPresentationWrapper = this.querySelector('[data-choices-presentation-wrapper]');
  }

  connectedCallback() {
    setTimeout(() => {
      this.initShowChoicesPresentation();
    }, 1000);

    document.addEventListener('calculator-drawer:finalSelectionUpdated', (event) => {
      this.showChoicesPresentation(event);
    });

    document.addEventListener('calculator-drawer:selectionCleared', (event) => {
      this.removeExistingChoice(event);
    });
  }

  initShowChoicesPresentation() {
    const detailsElements = document.querySelectorAll('.calculator-product__accordion .calculator__open-drawer');

    detailsElements.forEach((detailsElement) => {
      if (detailsElement.classList.contains('selection_added') && !detailsElement.classList.contains('locked')) {
        const finalSelectionTitle = detailsElement.querySelector('[data-form-final-selection-title]').textContent.trim();
        if (!finalSelectionTitle) return;

        const selectedImg = detailsElement.querySelector('.swatch-image');
        const defaultImg = detailsElement.querySelector('.default-swatch-image');
        const finalSelectionImg = selectedImg || defaultImg;
        if (!finalSelectionImg) return;

        this.showChoicesPresentation({
          detail: {
            formFinalSelectionTitle: finalSelectionTitle,
            formFinalSelectionImg: finalSelectionImg,
            isUsingDefaultImage: Boolean(defaultImg && !selectedImg),
          },
        });
      }
    });
  }

  showChoicesPresentation(event) {
    this.choicesPresentationWrapper.classList.add('active');
    this.addNewChoice(event);
  }

  addNewChoice(event) {
    const finalSelectionTitle = event.detail.formFinalSelectionTitle;
    const finalSelectionImg = event.detail.formFinalSelectionImg;
    const isUsingDefaultImage = event.detail.isUsingDefaultImage;
    const imgSrc = finalSelectionImg && finalSelectionImg.src ? finalSelectionImg.src : '';
    const imgAlt = finalSelectionImg && finalSelectionImg.alt ? finalSelectionImg.alt : '';

    const existingEntry = this.storedSelections.find((item) => item.selectionTitle === finalSelectionTitle);

    if (existingEntry) {
      existingEntry.selectionImgSrc = imgSrc;
      existingEntry.isUsingDefaultImage = isUsingDefaultImage;
      this.updateChoiceElement(finalSelectionTitle, imgSrc, imgAlt, isUsingDefaultImage);
      return;
    }

    this.storedSelections.push({
      selectionTitle: finalSelectionTitle,
      selectionImgSrc: imgSrc,
      isUsingDefaultImage: isUsingDefaultImage,
    });

    this.choicesPresentationContent.appendChild(
      this.buildChoiceElement(finalSelectionTitle, imgSrc, imgAlt, isUsingDefaultImage)
    );
  }

  findChoiceByTitle(finalSelectionTitle) {
    const titles = this.choicesPresentationContent.querySelectorAll('[data-selection-title]');

    for (const titleEl of titles) {
      if (titleEl.getAttribute('data-selection-title') === finalSelectionTitle) {
        return titleEl.closest('.selection-choice');
      }
    }

    return null;
  }

  updateChoiceElement(finalSelectionTitle, imgSrc, imgAlt, isUsingDefaultImage) {
    const choice = this.findChoiceByTitle(finalSelectionTitle);
    if (!choice) return;

    let choiceImg = choice.querySelector('.choice-img');

    if (!imgSrc) {
      const choiceImgWrap = choice.querySelector('.choice-img-wrap');
      if (choiceImgWrap) choiceImgWrap.remove();
      return;
    }

    if (!choiceImg) {
      const choiceImgWrap = document.createElement('div');
      choiceImgWrap.classList.add('choice-img-wrap');
      choiceImg = document.createElement('img');
      choiceImg.classList.add('choice-img');
      choiceImgWrap.appendChild(choiceImg);
      choice.appendChild(choiceImgWrap);
    }

    choiceImg.src = imgSrc;
    choiceImg.alt = imgAlt;
    choiceImg.classList.toggle('default-choice-img', Boolean(isUsingDefaultImage));
  }

  buildChoiceElement(finalSelectionTitle, imgSrc, imgAlt, isUsingDefaultImage) {
    const choice = document.createElement('div');
    choice.classList.add('selection-choice', 'd-flex', 'd-flex-col');

    const choiceTitle = document.createElement('h4');
    choiceTitle.setAttribute('data-selection-title', finalSelectionTitle);
    choiceTitle.textContent = finalSelectionTitle;
    choice.appendChild(choiceTitle);

    if (imgSrc) {
      const choiceImgWrap = document.createElement('div');
      choiceImgWrap.classList.add('choice-img-wrap');

      const choiceImg = document.createElement('img');
      choiceImg.src = imgSrc;
      choiceImg.alt = imgAlt;
      choiceImg.classList.add('choice-img');

      if (isUsingDefaultImage) {
        choiceImg.classList.add('default-choice-img');
      }

      choiceImgWrap.appendChild(choiceImg);
      choice.appendChild(choiceImgWrap);
    }

    return choice;
  }

  removeExistingChoice(event) {
    const finalSelectionTitle = event.detail.formFinalSelectionTitle;
    this.storedSelections = this.storedSelections.filter((item) => item.selectionTitle !== finalSelectionTitle);

    const choice = this.findChoiceByTitle(finalSelectionTitle);
    if (choice) choice.remove();
  }
}

if (!customElements.get('calculator-choices-presentation')) {
  customElements.define('calculator-choices-presentation', CalculatorChoicesPresentation);
}